'use client'

import { Heading, type HeadingProps } from '../../heading'

export const InfoModalSubtitle = (props: HeadingProps) => {
  return <Heading className="text-center" fontSize="2xl" {...props} />
}
